import { AuditOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import { useHasAccess } from '@components/HasAccess'
import Page from '@components/Page/Page'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import { Alert, Col } from 'antd'

const LegalsTab = () => {
  const { hasAccess } = useHasAccess()

  return (
    <Page rowGutter={[32, 32]} noWrapWithCol>
      <Col span={24}>
        <Alert
          title={`If your venue is managed by another group or company, or connected to a provider other than your main PMS provider, the user will need to opt in again when making their first booking at this venue. You can then configure data privacy and marketing opt-in settings below to ensure compliance with the law.`}
        />
      </Col>
      <Col span={12}>
        <FormCard
          title="Data privacy opt-in"
          icon={<AuditOutlined />}
          entity={Entity.venue}
          action={SBRMAction.Update}
          sections={['reoptinLegal']}
          disabled={!hasAccess(Permission.updateVenue)}
        />
      </Col>
      <Col span={12}>
        <FormCard
          title="Marketing opt-in"
          icon={<AuditOutlined />}
          entity={Entity.venue}
          action={SBRMAction.Update}
          sections={['reoptinMarketing']}
          disabled={!hasAccess(Permission.updateVenue)}
        />
      </Col>
    </Page>
  )
}

export default LegalsTab
